import { render } from "./DeleteFormRecord.vue?vue&type=template&id=ec1ec9ac"
import script from "./DeleteFormRecord.vue?vue&type=script&lang=js"
export * from "./DeleteFormRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__